import classNames from 'classnames';
import React from 'react';

import { AlmaLink } from '../alma-link';
import * as blogTypographyStyles from '../blog/blog-typography.module.css';
import { SimplePortableText } from '../simple-portable-text';
import * as styles from './blog-tof-cta.module.css';

interface BlogTofCtaProps {
	ctaAudience: string;
	ctaContent: any;
	ctaEyebrow?: string;
	ctaHeading: string;
	ctaLinkLabel: string;
	iterablePopup?: string;
	landingPageRoute?: string;
	link?: string;
	linkType?: LinkType;
	marketoPopup?: string;
	openInNewTab?: boolean;
	route?: string;
}

type LinkType =
	| 'directoryLink'
	| 'externalLink'
	| 'internalLink'
	| 'iterablePopup'
	| 'marketoPopup';

export const BlogTofCta: React.FC<BlogTofCtaProps> = ({
	ctaAudience,
	ctaContent,
	ctaEyebrow,
	ctaHeading,
	ctaLinkLabel,
	iterablePopup,
	landingPageRoute,
	link,
	linkType,
	marketoPopup,
	openInNewTab,
	route,
}) => {
	const isDirectoryLink = linkType === 'directoryLink';
	const isExternalLink = linkType === 'externalLink';
	const isInternalLink = linkType === 'internalLink';
	const isIterablePopup = linkType === 'iterablePopup';
	const isMarketoPopup = linkType === 'marketoPopup';
	const isProviderCta = ctaAudience === 'provider';

	return (
		<section
			className={classNames(
				styles.container,
				isProviderCta ? styles.providerCta : styles.consumerCta
			)}
		>
			<div className={styles.headerContent}>
				{ctaEyebrow && <h2 className='heading-xs'>{ctaEyebrow}</h2>}
				<h3 className={classNames(blogTypographyStyles.blogHeadingM)}>
					{ctaHeading}
				</h3>
			</div>
			<div className={styles.divider} />
			<SimplePortableText blocks={ctaContent} />
			{ctaLinkLabel && (
				<AlmaLink
					analytics={{
						enableGA4: isDirectoryLink || isIterablePopup,
						ga4Event: {
							name: isIterablePopup
								? 'article_Iterable_CTA_btn'
								: 'blog_directory_CTA_btn',
						},
					}}
					cta={{
						hasArrow: true,
						iterablePopup: isIterablePopup
							? iterablePopup
							: undefined,
						kind: 'link',
						landingPageRoute: isInternalLink
							? landingPageRoute
							: undefined,
						link:
							isDirectoryLink || isExternalLink
								? link
								: undefined,
						linkColor: isProviderCta ? 'cbb' : 'cmat',
						marketoPopup: isMarketoPopup ? marketoPopup : undefined,
						openInNewTab:
							isDirectoryLink || isExternalLink
								? openInNewTab
								: undefined,
						route: isInternalLink ? route : undefined,
						title: ctaLinkLabel,
					}}
				/>
			)}
		</section>
	);
};
